import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Typography,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Card,
  Grid,
  CardContent,
  IconButton,
  Chip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getPublicListCatalogueDiamant } from '../../redux/slices/catalogue-diamant.slice';
import {
  createInventaireDiamant,
  listViewInventaireDiamant,
  searchByCodeStockDiamant,
  updateInventaireDiamant,
  validateInventaireDiamant,
} from '../../redux/slices/stock-diamant.slice';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link, useParams } from 'react-router-dom';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';

const BCrumb = [
  {
    to: '/app',
    title: 'Home',
  },
  {
    to: '/app/stock-diamant/inventaire',
    title: 'Inventaire Diamant',
  },
  {
    title: 'Nouveau Inventaire',
  },
];

const steps = ['Config', 'Inventaire', 'Résumé'];

const InventaireDiamantDetailsContainer = () => {
  const [activeStep, setActiveStep] = useState(0);

  const params = useParams();
  const dispatch = useDispatch();
  const [dateDebut, setDateDebut] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [sku, setSku] = useState(null);
  const [inventaire, setInventaire] = useState(null);
  const [lst_diamant, set_lst_diamant] = useState([]);

  const load_diamants = () => {
    dispatch(getPublicListCatalogueDiamant())
      .unwrap()
      .then((res) => {
        console.log(res);
        set_lst_diamant(Array.isArray(res) ? res : []);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    load_diamants();
  }, []);

  // ✅ Step 1 : API call (simulate)
  const createInventaire = () => {
    console.log('Créer inventaire vide:', { date_debut: dateDebut, date_fin: dateFin, sku });
    dispatch(createInventaireDiamant({ date_debut: dateDebut, date_fin: dateFin, sku }))
      .unwrap()
      .then((res) => {
        setInventaire(res);
        setActiveStep(1);
      })
      .catch((err) => console.log(err));
  };
  const saveInventaire = (stock) => {
    if (inventaire?.idInventaireDia)
      dispatch(updateInventaireDiamant({ ...inventaire, stock_trouvee: stock }))
        .unwrap()
        .then((res) => {})
        .catch((err) => console.log(err));
  };

  // ✅ Step 2 : API update (simulate)
  const validerInventaire = (stock_trouvee) => {
    console.log('Inventaire validé:', inventaire);
    const data = {
      ...inventaire,
      stock_trouvee,
    };
    dispatch(validateInventaireDiamant(data))
      .unwrap()
      .then((res) => {
        setInventaire(res);
        setActiveStep(2);
      })
      .catch((err) => console.log(err));
  };

  const loadInventaire = () => {
    if (params?.id)
      dispatch(listViewInventaireDiamant(params?.id))
        .unwrap()
        .then((res) => {
          setInventaire(res);
          if (res?.status === 'en-cours') setActiveStep(1);
          else setActiveStep(2);
        })
        .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadInventaire();
  }, [params?.id]);

  return (
    <PageContainer title="Inventaire Diamant" description="">
      {/* breadcrumb */}
      <Breadcrumb title="Inventaire Diamant" items={BCrumb} />

      <Box sx={{ p: 0 }}>
        <Link to={'/app/stock-diamant/inventaire'}>
          <Button color="success">
            <FeatherIcon icon="arrow-left" width="16" /> List des inventaires
          </Button>
        </Link>

        {/* Stepper */}
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Page 1 : Config */}
        {activeStep === 0 && (
          <Card component={Paper} sx={{ borderRadius: 1 }}>
            <Typography variant="h6" sx={{ mb: 2 }} color={'primary.main'}>
              Nouveau inventaire
            </Typography>

            <Grid container spacing={2}>
              <Grid item lg={4}>
                <TextField
                  fullWidth
                  label="Date début"
                  type="date"
                  value={dateDebut}
                  onChange={(e) => setDateDebut(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item lg={4}>
                <TextField
                  fullWidth
                  label="Date fin"
                  type="date"
                  value={dateFin}
                  onChange={(e) => setDateFin(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item lg={4}>
                <Autocomplete
                  fullWidth
                  options={lst_diamant}
                  getOptionLabel={(item) => `${item?.sku} (${item?.famille})`}
                  value={sku}
                  onChange={(e, newValue) => setSku(newValue)}
                  renderInput={(params) => <TextField {...params} label="SKU (optionnel)" />}
                  sx={{ mb: 3, width: 300 }}
                />
              </Grid>
            </Grid>

            {dateDebut &&
              dateFin &&
              (new Date(dateDebut) > new Date(dateFin) || new Date(dateFin) > new Date()) && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                  ⚠️ La date de début doit être avant la date de fin
                </Typography>
              )}

            <Button
              variant="contained"
              onClick={createInventaire}
              disabled={!dateDebut || !dateFin || new Date(dateDebut) > new Date(dateFin)}
              sx={{ float: 'inline-end' }}
            >
              Créer & Commencer Inventaire
            </Button>
          </Card>
        )}

        {/* Page 2 : Inventaire */}
        {activeStep === 1 && (
          <InventaireDiamantInputList
            saveInventaire={saveInventaire}
            validerInventaire={validerInventaire}
            inventaire={inventaire}
          />
        )}

        {/* Page 3 : Résumé */}
        {activeStep === 2 && <InventaireDiamantResult inventaire={inventaire} />}
      </Box>
    </PageContainer>
  );
};

const InventaireDiamantInputList = ({ validerInventaire, saveInventaire, inventaire }) => {
  const dispatch = useDispatch();
  const [lst_stock, set_lst_stock] = useState([]);
  const [lst_stock_search, set_lst_stock_search] = useState([]);
  const [sel_new_stock, set_sel_new_stock] = useState(null);
  const { loading, error } = useSelector((state) => state.stock_diamant_fb_store);

  const onSearchStock = (event, value, reason) => {
    console.log(value);
    if (value && String(value).length >= 3)
      dispatch(searchByCodeStockDiamant(value))
        .unwrap()
        .then((res) => {
          set_lst_stock_search(Array.isArray(res) ? res : []);
        })
        .catch((err) => console.log(err));
  };

  const onAddStock = () => {
    if (Array.isArray(lst_stock) && sel_new_stock) {
      let tmp = [{ ...sel_new_stock, poids_cts_found: 0 }, ...lst_stock];
      set_lst_stock(tmp);
      saveInventaire(tmp);
    }
  };
  const onDeleteStock = (code_inventaire) => {
    if (Array.isArray(lst_stock) && code_inventaire) {
      let tmp = lst_stock.filter((el) => el?.code_inventaire != code_inventaire);
      set_lst_stock(tmp);
      saveInventaire(tmp);
    }
  };

  const updatItemValue = (code_inventaire, field, value) => {
    if (Array.isArray(lst_stock)) {
      let tmp = lst_stock.map((el) =>
        el?.code_inventaire == code_inventaire ? { ...el, [field]: value } : el,
      );
      set_lst_stock(tmp);
      saveInventaire(tmp);
    }
  };

  const onSubmit = () => {
    if (Array.isArray(lst_stock)) {
      validerInventaire(lst_stock);
    }
  };

  useEffect(() => {
    if (Array.isArray(inventaire?.stock_trouvee)) {
      set_lst_stock(inventaire?.stock_trouvee);
    }
  }, [inventaire?.stock_trouvee]);
  return (
    <Card padding={2} sx={{ py: 1, borderRadius: 1 }}>
      <CardContent padding={0} sx={{ py: 1, paddingBottom: '4px !important' }}>
        <Box>
          <Grid container spacing={1}>
            <Grid item lg={12} textAlign={'end'}>
              <Button variant="contained" size="small" onClick={onSubmit} sx={{ px: 4 }}>
                Valider
              </Button>
            </Grid>
            <Grid item lg={6}>
              <Typography variant="h5" fontWeight={600}>
                Stock Diamant
              </Typography>
              <Autocomplete
                options={Array.isArray(lst_stock_search) ? lst_stock_search : []}
                getOptionLabel={(el) => (el ? `${el?.code_inventaire}` : '')}
                loading={loading}
                onInputChange={onSearchStock}
                onChange={(event, newValue) => {
                  return set_sel_new_stock(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    {...params}
                    size="small"
                    placeholder="Num Inventaire..."
                    aria-label="fb"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6}>
              <Typography color={'primary.main'} variant="h5" fontWeight={600} sx={{ opacity: 0 }}>
                Action
              </Typography>
              <Button onClick={onAddStock} variant="contained" color="success" sx={{ px: 3 }}>
                Ajouter
              </Button>
            </Grid>
          </Grid>
        </Box>

        <TableContainer>
          <Table
            size="small"
            stickyHeader
            sx={{ '& .MuiTableCell-root': { borderLeft: '1px solid rgba(224, 224, 224, 1)' } }}
          >
            <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
              <TableRow>
                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Num Inv
                  </Typography>
                </TableCell>

                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    SKU
                  </Typography>
                </TableCell>

                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Poids CTS Trouvé
                  </Typography>
                </TableCell>

                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Couleur
                  </Typography>
                </TableCell>
                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Pureté
                  </Typography>
                </TableCell>

                <TableCell padding="none" sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    ...
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {Array.isArray(lst_stock) &&
                lst_stock.map((el) => (
                  <TableRow
                    key={el?.idStock}
                    sx={{
                      backgroundColor: +el?.poids_cts_found > 0 ? '#00c29280' : '#e46a7680',
                    }}
                  >
                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography color="primary.main" variant="subtitle2" fontWeight="600">
                        {el?.code_inventaire}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle2" fontWeight="500">
                        {el?.catalogueDia?.sku}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle2" fontWeight="400">
                        <TextField
                          fullWidth
                          type="number"
                          value={el?.poids_cts_found}
                          onChange={(e) =>
                            updatItemValue(el?.code_inventaire, 'poids_cts_found', e?.target?.value)
                          }
                          size="small"
                          placeholder="..."
                        />
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle2" fontWeight="400">
                        {el?.couleur}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle2" fontWeight="400">
                        {el?.purete}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'center' }}>
                      <IconButton
                        sx={{ display: 'inline-block' }}
                        color="error"
                        onClick={(e) => onDeleteStock(el?.code_inventaire)}
                      >
                        <FeatherIcon icon="trash" width="16" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

const InventaireDiamantResult = ({ inventaire }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [totals, setTotals] = useState({});
  const [trouves, setTrouves] = useState([]);
  const [manquants, setManquants] = useState([]);
  const [problemes, setProblemes] = useState([]);

  const processResult = () => {
    if (!inventaire) return;
    if (Array.isArray(inventaire?.resultat_stock_ok)) setTrouves(inventaire?.resultat_stock_ok);
    if (Array.isArray(inventaire?.resultat_stock_manquant))
      setManquants(inventaire?.resultat_stock_manquant);
    if (Array.isArray(inventaire?.resultat_stock_probleme))
      setProblemes(inventaire?.resultat_stock_probleme);
  };
  useEffect(() => {
    processResult(inventaire);
  }, [inventaire]);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Résumé Inventaire
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid
          container
          spacing={1}
          sx={{ mb: 2, pb: 2, borderBottom: '1px solid rgba(224, 224, 224, 0.3)' }}
        >
          <Grid item lg={3}>
            <Typography variant="h6">
              Num:
              <Typography component={'span'} variant="h6" color={'primary.main'}>
                {' '}
                {inventaire?.ref}
              </Typography>
            </Typography>
          </Grid>

          <Grid item lg={3}>
            <Typography variant="h6">
              Status:
              <Chip
                size="small"
                variant="outlined"
                color="success"
                label={'Validé'}
                sx={{ borderRadius: 1, py: 0, ml: 1 }}
              />
            </Typography>
          </Grid>
          <Grid item lg={3}>
            <Typography variant="h6">
              Date: {`${inventaire?.date_debut} - ${inventaire?.date_fin}`}
            </Typography>
          </Grid>
          <Grid item lg={3}>
            <Typography variant="h6">Sku: {inventaire?.sku || '-'}</Typography>
          </Grid>
          <Grid item lg={3}>
            <Typography variant="h6">Crée par : {inventaire?.owner || '-'}</Typography>
          </Grid>
          <Grid item lg={3}>
            <Typography variant="h6">
              Crée le : {String(inventaire?.created_at).substring(0, 10)}
            </Typography>
          </Grid>
          <Grid item lg={12} textAlign={'end'}>
            <Button variant="contained" color="success" size="small" sx={{ px : 3 }}>
              Imprimer
            </Button>
          </Grid>
        </Grid>

        <Typography textAlign={'center'}>
          📦 Articles trouvés: {+trouves.length + +problemes.length} /{' '}
          {+trouves.length + +problemes.length + +manquants.length}
        </Typography>
        {/* <Typography>✅ Poids total trouvé: {totalTrouve} CTS</Typography>
        <Typography>❌ Poids manquant: {(totalAttendu - totalTrouve).toFixed(2)} CTS</Typography> */}
      </Paper>

      <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)}>
        <Tab label={`✅ Trouvés (${trouves.length})`} />
        <Tab label={`❌ Manquants (${manquants.length})`} />
        <Tab label={`⚖️ Problèmes (${problemes.length})`} />
      </Tabs>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Num</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>Poids Attendu</TableCell>
              <TableCell>Poids Trouvé</TableCell>
              <TableCell>Couleur</TableCell>
              <TableCell>Pureté</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tabIndex === 0 ? trouves : tabIndex === 1 ? manquants : problemes).map((row) => (
              <TableRow key={row?.code_inventaire}>
                <TableCell>{row?.code_inventaire}</TableCell>
                <TableCell>{row?.catalogueDia?.sku}</TableCell>
                <TableCell>{row.poids_cts}</TableCell>
                <TableCell>{row.poids_cts_found || '-'}</TableCell>
                <TableCell>{row.couleur}</TableCell>
                <TableCell>{row.purete}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InventaireDiamantDetailsContainer;
